(function(){
  'use strict';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const CEP_KEY = 'dj_last_cep';
  const $ = (s,c) => (c||document).querySelector(s);

  function maskCep(v){ return (v||'').replace(/\D/g,'').slice(0,8).replace(/(\d{5})(\d)/, '$1-$2'); }
  function fmtBRL(cents){ return 'R$ ' + (cents/100).toFixed(2).replace('.', ','); }

  async function resolveCep(cepDigits){
    try {
      const r = await fetch('https://viacep.com.br/ws/' + cepDigits + '/json/');
      if (!r.ok) return null;
      const data = await r.json();
      if (data.erro) return null;
      return { uf: data.uf, city: data.localidade };
    } catch(e){ return null; }
  }

  function init(){
    const toggle = $('[data-shipping-toggle]');
    const panel = $('[data-shipping-panel]');
    const input = $('[data-shipping-cep]');
    const calc = $('[data-shipping-calc]');
    const loading = $('[data-shipping-loading]');
    const error = $('[data-shipping-error]');
    const results = $('[data-shipping-results]');
    if (!toggle || !panel || !input || !calc) return;

    const saved = localStorage.getItem(CEP_KEY);
    if (saved) input.value = saved;

    toggle.addEventListener('click', function(){
      const open = panel.hidden === false;
      panel.hidden = open;
      toggle.setAttribute('aria-expanded', !open);
      if (!open) setTimeout(() => input.focus(), 80);
    });

    input.addEventListener('input', function(){
      input.value = maskCep(input.value);
      if (error) { error.hidden = true; error.textContent = ''; }
    });
    input.addEventListener('keydown', function(e){
      if (e.key === 'Enter') { e.preventDefault(); calc.click(); }
    });

    calc.addEventListener('click', async function(){
      if (error) { error.hidden = true; error.textContent = ''; }
      if (results) results.innerHTML = '';
      const cepDigits = (input.value || '').replace(/\D/g,'');
      if (cepDigits.length !== 8) {
        if (error) { error.textContent = 'Digite um CEP valido (8 digitos)'; error.hidden = false; }
        return;
      }
      localStorage.setItem(CEP_KEY, input.value);

      try {
        const cartRes = await fetch(root + 'cart.js', { credentials: 'same-origin' });
        const cart = await cartRes.json();
        if (!cart.items || cart.items.length === 0) {
          if (error) { error.textContent = 'Adicione produtos ao carrinho primeiro'; error.hidden = false; }
          return;
        }
      } catch(e) {}

      calc.disabled = true; calc.textContent = '...';
      if (loading) loading.hidden = false;

      const cepInfo = await resolveCep(cepDigits);
      if (!cepInfo || !cepInfo.uf) {
        if (loading) loading.hidden = true;
        calc.disabled = false; calc.textContent = 'Calcular';
        if (error) { error.textContent = 'CEP nao encontrado'; error.hidden = false; }
        return;
      }

      const params = new URLSearchParams();
      params.append('shipping_address[zip]', input.value);
      params.append('shipping_address[country]', 'Brazil');
      params.append('shipping_address[province]', cepInfo.uf);
      if (cepInfo.city) params.append('shipping_address[city]', cepInfo.city);

      try {
        const r = await fetch(root + 'cart/shipping_rates.json?' + params.toString(), { credentials: 'same-origin' });
        if (!r.ok) {
          const txt = await r.text();
          throw new Error(txt || 'Erro ao calcular frete');
        }
        const data = await r.json();
        const rates = data.shipping_rates || [];
        if (loading) loading.hidden = true;
        if (rates.length === 0) {
          if (error) { error.textContent = 'Nao encontramos opcoes de frete para ' + cepInfo.uf + '. Verifique se os produtos tem peso cadastrado.'; error.hidden = false; }
          return;
        }
        if (results) {
          results.innerHTML = rates.map(function(rate){
            const cents = Math.round(parseFloat(rate.price) * 100);
            const isFree = cents === 0;
            return '<div class="cart-shipping-option">' +
              '<div><strong>' + (rate.presentment_name || rate.name) + '</strong>' +
              (rate.delivery_date ? '<small>Entrega ' + rate.delivery_date + '</small>' : (rate.delivery_range ? '<small>' + rate.delivery_range.join(' a ') + ' dias uteis</small>' : '')) +
              '</div>' +
              '<span class="cart-shipping-price' + (isFree ? ' free' : '') + '">' + (isFree ? 'GRATIS' : fmtBRL(cents)) + '</span>' +
            '</div>';
          }).join('');
        }
        const cheapest = rates.reduce((min, r) => parseFloat(r.price) < parseFloat(min.price) ? r : min);
        const status = document.getElementById('cartShipping');
        if (status) {
          const cents = Math.round(parseFloat(cheapest.price) * 100);
          status.innerHTML = cents === 0 ? '<span style="color:var(--brand);font-weight:700">Gratis</span>' : 'a partir de ' + fmtBRL(cents);
        }
      } catch(err) {
        if (loading) loading.hidden = true;
        if (error) {
          error.hidden = false;
          let msg = err.message || 'Erro ao calcular';
          try { const obj = JSON.parse(msg); msg = obj.message || obj.description || msg; } catch(e){}
          if (msg.length > 200) msg = msg.substring(0,200);
          error.textContent = msg;
        }
      } finally {
        calc.disabled = false; calc.textContent = 'Calcular';
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
